import type { Notification } from '../parts/Header/NotificationBell';
import { getFutureDate, convertToMoment } from './dateUtils';

/**
 * Returns a list of Notification objects for campaigns
 * ending in exactly 7 days or today (1 day after).
 */
export function getCampaignNotifications(data, loggedInUser): Notification[] {
    const sevenDaysAfter = getFutureDate(7);
    const oneDayAfter = getFutureDate(1);

    return data
        .map((entry) => {
            const owner = (entry.promotion_owner || '').trim();
            const user = (loggedInUser || '').trim();
            if (owner !== user) return null;

            const end = convertToMoment(entry.promotion_end_utc);
            let reminder: '7' | '1' | null = null;
            if (end.isSame(sevenDaysAfter, 'day')) reminder = '7';
            else if (end.isSame(oneDayAfter, 'day')) reminder = '1';

            if (!reminder) return null;

            const daysText =
                reminder === '7'
                ? 'ends in 7 days.'
                : 'ends today.';
            const archText =
                reminder === '7'
                ? 'will be archived in 7 days'
                : 'will be archived today';

            const message = `${entry.promotion_name} campaign ${daysText} ` +
                `If the timeline was extended, make sure to change the end date on the General Info tab of the campaign. ` +
                `Otherwise, it ${archText} as well as all the assigned promotions.`;

            return {
                id: entry.promotion_id,
                title: entry.promotion_name,
                message,
                read: false,
                enabledButton: true,
                buttonName: "Change Dates",
                redirect: `/editCampaign/${entry.promotion_id}`
            } as Notification;
    })
    .filter((n): n is Notification => n !== null);
}
